import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    input,
    OnChanges,
    signal,
    WritableSignal,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { EntityLinkDocumentComponent } from '@connect-services/client/components/entity-link-document/entity-link-document.component';
import { EntityProperties } from '@connect-services/client/models/panel.model';
import { DocumentIdentifiers, DocumentService } from '@connect-services/client/services/document.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { Document } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ButtonComponent,
        EntityLinkDocumentComponent,
        ExpansionPanelComponent,
        LoadingComponent,
        RessourcesModule,
    ],
    selector: 'app-entity-link-document-list',
    templateUrl: './entity-link-document-list.component.html',
})
export class EntityLinkDocumentListComponent implements OnChanges {
    public readonly areDocumentsLost = input(false);
    public readonly data = input.required<DocumentIdentifiers>();
    public readonly dataEntity = input<EntityProperties>();
    public readonly documentList: WritableSignal<Document[]> = signal([]);
    public readonly documentService = inject(DocumentService);
    public readonly isLoading = signal(true);
    public readonly subTitle = input('');

    protected readonly ButtonType = ButtonType;

    private destroyRef = inject(DestroyRef);
    private documentChanges: Subscription | undefined;

    public constructor() {
        this.destroyRef.onDestroy(() => {
            this.documentChanges?.unsubscribe();
        });
    }

    public async ngOnChanges(): Promise<void> {
        this.documentChanges?.unsubscribe();

        await this.documentService.updateDocumentList(this.documentList, this.data());

        this.documentChanges = this.documentService.documentListChanges.subscribe(async () => {
            await this.documentService.updateDocumentList(this.documentList, this.data());
        });

        this.isLoading.set(false);
    }
}
